import { Link } from 'react-router-dom';
import { gameCategories } from '@/mocks/games';

export default function CategoriesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            游戏分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大游戏分类，总有一款适合您
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {gameCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-100 rounded-xl p-5 text-center cursor-pointer transition-all hover:scale-[1.02] hover:bg-primary-50"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center bg-background-50 rounded-xl group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="font-heading text-base text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-2 line-clamp-2">{cat.description}</p>
              <span className="text-xs text-primary-500 font-medium whitespace-nowrap">{cat.count}款游戏</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}